<template>
  <span class="date-time-picker-container">
    <input type="text" ref="input" :value="value"
      :placeholder="placeholder"/>
  </span>
</template>

<script>
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'DateTimePicker',
  data() {
    return {
      fp: null, // the flatpickr instance
    };
  },
  props: {
    value: { required: true },
    placeholder: {
      type: String,
      default: '',
    },
    outputFormat: {
      type: String,
      default: 'timestamp',
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    options(newVal) {
      Object.entries(newVal).forEach((entry) => {
        const [key, value] = entry;
        this.fp.set(key, value);
      });
    },
    value(newVal) {
      this.fp.setDate(newVal);
    },
  },
  mounted() {
    this.fp = flatpickr(this.$refs.input, {
      altInput: true,
      defaultDate: this.value,
      enableTime: true,
      onChange: (selectedDates) => {
        if (selectedDates.length > 0) {
          const dateObject = selectedDates[0];
          const { outputFormat } = this.$props;
          if (outputFormat === 'timestamp') {
            this.$emit('input', dateObject.getTime());
          } else {
            this.$emit('input', flatpickr.formatDate(dateObject, outputFormat));
          }
        }
      },
      ...this.options,
    });
  },
};
</script>

<style lang="scss">

.date-time-picker-container .flatpickr-input {
  margin: 0 0.75rem 0 0;
  font-size: 0.875rem;
  color: #444444;
}

</style>
